module.exports = __webpack_public_path__ + "static/img/zhtsgbjt.4a70738.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/zhtsgbjt.png
// module id = kANp
// module chunks = 1